import { JobType } from '@business/entities/job';

export function getJobTitle(type: JobType) {
  switch (type) {
    case JobType.exportOrganizations:
      return 'Exporting Organizations';
    case JobType.importActivity:
      return 'Importing Activities';
    case JobType.importContact:
      return 'Importing Contacts';
    case JobType.importTiers:
      return 'Importing Products';
    case JobType.importProducts:
      return 'Importing Products';
  }
}
